import axios from "axios";
import { store } from "../Store/store";

const REACT_APP_API_ENDPOINT_BASE_URL =
  process.env.REACT_APP_API_ENDPOINT_BASE_URL || "http://localhost:3003";
const REACT_APP_API_ENDPOINT_PREFIX =
  process.env.REACT_APP_API_ENDPOINT_PREFIX || "/api/dev";

const getToken = () => store.getState().authentication.token;

const axiosConfig = {
  mode: "cors",
  baseURL: REACT_APP_API_ENDPOINT_BASE_URL + REACT_APP_API_ENDPOINT_PREFIX,
  headers: {
    "Content-type": "application/json",
    Accept: "application/json",
    Authorization: window.localStorage.getItem("token") || getToken() || "",
  },
};

const configuredAxios = axios.create(axiosConfig);

const getUserIP = async () => {
  try {
    const response = await axios.get("https://api64.ipify.org?format=json");
    return response.data.ip;
  } catch (error) {
    return "";
  }
};

configuredAxios.interceptors.request.use(async (config) => {
  if (config.url === "/auth/check" || config.url === "/auth/login") {
    const userIP = await getUserIP();
    if (userIP) {
      config.headers["X-User-IP"] = userIP;
    }
  }
  config.headers.Authorization = getToken() || "";
  return config;
});

export const Axios = configuredAxios;
